import React from 'react';
import SafetyVANContents from '../../../component/Safety/VAN/SafetyVANContents';

const VAN = () => {
  return <SafetyVANContents />;
};

export default VAN;
